<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF EDUCATION & SPORTS</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Contact</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Physical Education & Sports</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Agriculture</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Physical Education & Sports </b>
                    – The Bachelor of Physical Education & Sports (B.P.E.S.) program at ARNI School of Education &
                    Sports is designed to equip students with a deep understanding of physical fitness, sports sciences,
                    and coaching methodologies. The B.P.E.S. curriculum is divided into six semesters and includes core
                    subjects, electives, practical training, and research projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundation of Physical Education &
                    Sports Science</p>
                <ul>
                    <li> Introduction to Physical Education & Sports</li>
                    <li>General English I</li>
                    <li>Exercise Physiology</li>
                    <li> History & Philosophy of Physical Education</li>
                    <li> Basic Sports Training & Techniques</li>
                    <li>Basics of Physiotherapy</li>
                    <li>Practical: Track & Field Events, Yoga, Basic Gymnastics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Advanced Fitness & Training
                    Principles</p>
                <ul>
                    <li> Sports Psychology & Athlete Motivation</li>
                    <li> Environmental Studies</li>
                    <li> First Aid & Sports Injury Management</li>
                    <li>Fitness & Conditioning for Athletes</li>
                    <li> Recreation & Adventure Sports</li>
                    <li> Practical: Strength Training, Team Sports (Football, Basketball, Volleyball)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Coaching & Officiating in Sports</p>
                <ul>
                    <li>General English II</li>
                    <li>Methods of Physical Education</li>
                    <li>Rule of game and sports (Theory Part-III Track & Field and Cross Country)</li>
                    <li>Officiating & Rules of Various Sports</li>
                    <li>Sports Management</li>
                    <li>Leadership & Ethics in Sports</li>
                    <li>Practical: Coaching Drills, Refereeing, Swimming, Martial Arts</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Sports Management & Performance
                    Analysis</p>
                <ul>
                    <li>Event Management in Sports</li>
                    <li>Advanced Strength & Conditioning</li>
                    <li>Adapted Physical Education for Special Populations</li>
                    <li>Motor Learning & Skill Acquisition</li>
                    <li>Research Methodology in Physical Education</li>
                    <li>Practical: Advanced Coaching Techniques, Sports Performance Testing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Specializations & Internship
                    Training</p>
                <ul>
                    <li>Sports Journalism & Media Management</li>
                    <li>Talent Identification & Development in Sports</li>
                    <li>Sports Sociology & Contemporary Issues</li>
                    <li>Elective-I</li>
                    <li>Practical: Internship in Schools/Clubs/Gyms</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Capstone Project & Career Readiness
                </p>
                <ul>
                    <li>Legal & Ethical Aspects of Sports</li>
                    <li> Entrepreneurship in Fitness & Sports</li>
                    <li> Major Project/Dissertation in Physical Education & Sports</li>
                    <li> Elective-II</li>
                    <li> Internship/Industrial Exposure Training</li>
                    <li> Seminar & Viva Voce</li>
                </ul>
            </div>

        </div>

    </div>
</section>
